var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPartyingFace(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "partying_face"
  }, /*#__PURE__*/React.createElement("g", {
    id: "gold"
  }, /*#__PURE__*/React.createElement("path", {
    id: "face",
    d: "M9.9375 19.5002C6.06094 19.5002 1.875 17.0689 1.875 11.733C1.875 6.39707 6.06094 3.96582 9.9375 3.96582C12.0906 3.96582 14.0781 4.67363 15.5516 5.96582C17.1484 7.38457 17.9969 9.38457 17.9969 11.733C17.9969 14.0814 17.1484 16.0689 15.5516 17.4861C14.0781 18.7783 12.0766 19.5002 9.9375 19.5002Z",
    fill: "url(#paint0_radial_9893_10658)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.5924 7.11572C17.3549 8.38135 17.7455 9.8376 17.7189 11.3157C17.7189 13.6595 16.8705 15.6517 15.2736 17.0688C13.8002 18.361 11.8002 19.0829 9.65957 19.0829C7.1502 19.0829 4.51426 18.0626 2.96582 15.8954C4.46113 18.3501 7.27207 19.5001 9.9377 19.5001C12.0768 19.5001 14.0783 18.7782 15.5518 17.486C17.1486 16.0673 17.9971 14.0813 17.9971 11.7329C17.9971 9.9626 17.5143 8.38916 16.5924 7.11572Z",
    fill: "#EB8F00"
  })), /*#__PURE__*/React.createElement("g", {
    id: "facial_expressions"
  }, /*#__PURE__*/React.createElement("g", {
    id: "face-with-party-horn-and-party-hat"
  }, /*#__PURE__*/React.createElement("g", {
    id: "blush"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    opacity: 0.8,
    d: "M5.28125 13.7656C6.7914 13.7656 8.01562 12.6114 8.01562 11.1875C8.01562 9.76364 6.7914 8.60938 5.28125 8.60938C3.7711 8.60938 2.54688 9.76364 2.54688 11.1875C2.54688 12.6114 3.7711 13.7656 5.28125 13.7656Z",
    fill: "url(#paint1_radial_9893_10658)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    opacity: 0.8,
    d: "M14.7188 13.7656C16.2289 13.7656 17.4531 12.6114 17.4531 11.1875C17.4531 9.76364 16.2289 8.60938 14.7188 8.60938C13.2086 8.60938 11.9844 9.76364 11.9844 11.1875C11.9844 12.6114 13.2086 13.7656 14.7188 13.7656Z",
    fill: "url(#paint2_radial_9893_10658)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "prop"
  }, /*#__PURE__*/React.createElement("g", {
    id: "confetti"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M3.75 3.125C4.35406 3.125 4.84375 2.77522 4.84375 2.34375C4.84375 1.91228 4.35406 1.5625 3.75 1.5625C3.14594 1.5625 2.65625 1.91228 2.65625 2.34375C2.65625 2.77522 3.14594 3.125 3.75 3.125Z",
    fill: "#FF00A2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M8.35124 4.57356C8.60752 4.31728 8.54321 3.83746 8.20761 3.50186C7.872 3.16626 7.39219 3.10195 7.13591 3.35823C6.87963 3.61451 6.94394 4.09433 7.27954 4.42993C7.61514 4.76553 8.09496 4.82984 8.35124 4.57356Z",
    fill: "#FD3B3B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M11.7024 3.32789C12.2756 2.88419 12.5733 2.30875 12.3673 2.04261C12.1613 1.77647 11.5296 1.9204 10.9564 2.3641C10.3832 2.80779 10.0855 3.38323 10.2915 3.64937C10.4975 3.91552 11.1291 3.77158 11.7024 3.32789Z",
    fill: "#00EEFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M4.05598 13.6419C4.2727 13.5167 4.22103 13.0215 3.94057 12.5358C3.66012 12.05 3.25708 11.7577 3.04036 11.8828C2.82364 12.0079 2.8753 12.5032 3.15576 12.9889C3.43622 13.4747 3.83926 13.767 4.05598 13.6419Z",
    fill: "#0048FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M15.0781 18.125C15.3802 18.125 15.625 17.7402 15.625 17.2656C15.625 16.791 15.3802 16.4062 15.0781 16.4062C14.7761 16.4062 14.5312 16.791 14.5312 17.2656C14.5312 17.7402 14.7761 18.125 15.0781 18.125Z",
    fill: "#F63BBE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M18.2078 9.17696C18.6665 8.85409 18.9577 8.47796 18.8584 8.33683C18.7591 8.19571 18.3067 8.34303 17.8481 8.66589C17.3894 8.98876 17.0981 9.36489 17.1975 9.50602C17.2968 9.64715 17.7491 9.49982 18.2078 9.17696Z",
    fill: "#00CC00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M3.51245 18.912C3.69283 18.7936 3.60879 18.3467 3.32474 17.9138C3.0407 17.4809 2.66421 17.2259 2.48383 17.3443C2.30345 17.4626 2.38749 17.9095 2.67154 18.3424C2.95559 18.7753 3.33208 19.0303 3.51245 18.912Z",
    fill: "#0048FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M2.37133 15.8589C2.8878 15.8223 3.2941 15.6181 3.27883 15.4029C3.26355 15.1877 2.83249 15.043 2.31602 15.0796C1.79954 15.1163 1.39324 15.3204 1.40852 15.5356C1.42379 15.7508 1.85486 15.8956 2.37133 15.8589Z",
    fill: "#7ACDED"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M3.76864 13.8123C4.38859 13.7711 4.88327 13.619 4.87353 13.4726C4.86379 13.3262 4.35332 13.241 3.73336 13.2822C3.11341 13.3235 2.61874 13.4756 2.62848 13.622C2.63822 13.7684 3.14869 13.8536 3.76864 13.8123Z",
    fill: "#FF82B2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M18.5781 12.2188C18.4453 11.7595 18.1281 11.3751 17.7031 11.1563C16.9844 10.7657 16.0844 11.0329 15.6953 11.7517C15.6922 11.7563 15.6906 11.761 15.6875 11.7657C15.3625 12.3782 15.5922 13.1392 16.2031 13.4688C16.4453 13.6048 16.7297 13.6438 17 13.5782C17.2781 13.5157 17.5125 13.3329 17.6406 13.0782C17.7797 12.7845 17.7672 12.4407 17.6094 12.1563C17.4812 11.9063 17.2328 11.7407 16.9531 11.7188C16.7922 11.7157 16.6609 11.8438 16.6578 12.0048C16.6562 12.1501 16.7625 12.2751 16.9062 12.297C16.9859 12.3017 17.0578 12.3501 17.0938 12.422C17.1484 12.5329 17.1594 12.6626 17.125 12.7813C17.0719 12.886 16.975 12.961 16.8594 12.9845C16.7328 13.0173 16.5984 13.0001 16.4844 12.9376C16.3281 12.8548 16.2109 12.7142 16.1562 12.547C16.1094 12.3751 16.1266 12.1923 16.2031 12.0313C16.3125 11.8188 16.5047 11.6595 16.7344 11.5938C16.9641 11.5282 17.2078 11.5501 17.4219 11.6563C17.7016 11.8095 17.9094 12.0688 18 12.3751C18.0953 12.6829 18.0609 13.0157 17.9062 13.297C17.6094 13.8595 17.0312 14.2345 16.1875 14.2345C15.7031 14.2345 12.8203 14.1563 12.8203 14.1563L12.8547 14.8751L16.1562 14.8282C17.1406 14.8282 17.9531 14.4376 18.4219 13.5626C18.6687 13.1595 18.725 12.6673 18.5781 12.2188Z",
    fill: "url(#paint3_linear_9893_10658)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M10.9376 14.5312C11.0329 14.6328 11.1063 14.7516 11.1563 14.8812L12.9454 14.8703C12.9454 14.6359 12.9142 14.4016 12.9142 14.1516C12.4454 14.1359 11.4798 14.1203 11.1798 14.1094C11.136 14.2703 11.0501 14.4172 10.9282 14.5312H10.9376Z",
    fill: "#7F0099"
  })), /*#__PURE__*/React.createElement("g", {
    id: "hat"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M16.375 8.5625L16.9219 8.64062L17.0625 8.09375L17.1406 7.78125L14 7.34375C15.4219 8.42188 16.2813 8.5625 16.375 8.5625Z",
    fill: "#FF4545"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M18.8906 0.84375L17.625 1.5625L17.3125 1.73438L18.625 1.92188C18.7187 1.53125 18.8906 0.84375 18.8906 0.84375Z",
    fill: "#FF4545"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M16.0938 2.42188L14.7969 3.15625L18.1875 3.64062L18.4063 2.75L16.0938 2.42188Z",
    fill: "#FF4545"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M12.3906 4.51562H12.375L17.7656 5.29688L17.9688 4.46875L13.5781 3.84375L12.3906 4.51562Z",
    fill: "#FF4545"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M12.8438 6.3125L17.3438 6.95313L17.5625 6.10938L12.1406 5.32812C12.2031 5.5 12.3906 5.84375 12.8438 6.3125Z",
    fill: "#FF4545"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M13.5781 3.84375L17.9688 4.46875L18.1875 3.64062L14.7969 3.15625L13.5781 3.84375Z",
    fill: "#FF9C9C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    d: "M18.5312 2.26562C18.5312 2.26562 18.5781 2.04687 18.6094 1.9375L17.2969 1.75L16.0781 2.4375L18.3906 2.76563L18.5312 2.26562Z",
    fill: "#FF9C9C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_22",
    d: "M11.9219 4.76562L12.0937 5.26563C12.1 5.29375 12.1109 5.32031 12.125 5.34375L17.5469 6.125L17.75 5.29688L12.3594 4.53125L11.9219 4.76562Z",
    fill: "#FF9C9C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_23",
    d: "M13.9375 7.29688C13.9531 7.3125 13.9844 7.32812 14 7.34375L17.1406 7.79688L17.3438 6.96875L12.8438 6.32812C13.1859 6.675 13.5516 6.99844 13.9375 7.29688Z",
    fill: "#FF9C9C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_24",
    d: "M18.875 1.76562C19.2892 1.76562 19.625 1.42984 19.625 1.01562C19.625 0.601411 19.2892 0.265625 18.875 0.265625C18.4608 0.265625 18.125 0.601411 18.125 1.01562C18.125 1.42984 18.4608 1.76562 18.875 1.76562Z",
    fill: "#C93737"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Vector_25",
    d: "M11.2249 14.3485C11.4546 14.1501 11.5983 13.8704 11.6265 13.5673C11.6702 13.2626 11.5796 12.9548 11.3765 12.7235C11.0124 12.2454 9.99989 12.3642 9.99989 12.3642C9.72802 12.3751 9.41396 12.5048 9.45302 12.8173C9.50458 12.997 9.64989 13.1345 9.83114 13.1751C10.2311 13.2704 10.8015 13.1751 10.8171 13.5813C10.8358 14.0376 10.1358 13.8501 10.0796 14.3329C10.0233 14.8157 10.8171 14.7517 10.8171 15.0845C10.8171 15.3392 10.5561 15.3829 10.2811 15.4407C10.0452 15.4892 9.59208 15.5626 9.55614 15.8329C9.52021 16.1032 9.67489 16.436 10.3124 16.3392C11.3155 16.1829 11.653 15.6376 11.653 15.3001C11.6593 14.9345 11.503 14.586 11.2249 14.3485Z",
    fill: "#422B0D"
  }), /*#__PURE__*/React.createElement("g", {
    id: "smiling-eyes-grinning-face"
  }, /*#__PURE__*/React.createElement("g", {
    id: "eyes"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_26",
    d: "M7.79061 10.2232L7.76717 10.1936L7.70467 10.1139L7.62498 10.0279C7.59373 9.99355 7.55623 9.95605 7.51873 9.91855C7.47967 9.88105 7.43904 9.84512 7.39529 9.8123C7.35623 9.78262 7.31561 9.75605 7.27186 9.73262C7.24217 9.71543 7.20936 9.70293 7.17498 9.69668C7.16404 9.69512 7.15467 9.69512 7.14373 9.69668C7.14373 9.69668 7.14373 9.69668 7.13123 9.69668H7.15936H7.07811H7.08904C7.08279 9.69512 7.07811 9.69512 7.07186 9.69668C7.03748 9.70293 7.00467 9.71543 6.97498 9.73262C6.93123 9.75605 6.89061 9.78262 6.85154 9.8123C6.81092 9.84355 6.76873 9.88105 6.72811 9.91855C6.65154 9.99355 6.58436 10.0748 6.53748 10.1232L6.46248 10.2123L6.42811 10.2514C6.21561 10.4873 5.85936 10.5248 5.60154 10.3404C5.43748 10.2264 5.35311 10.0279 5.38436 9.82949C5.38436 9.82949 5.39529 9.77012 5.42342 9.67324C5.46717 9.52324 5.52967 9.37949 5.60779 9.24512C5.72967 9.02324 5.89529 8.82793 6.09373 8.67168C6.22967 8.56855 6.37967 8.48574 6.54061 8.42793C6.58436 8.41074 6.63123 8.39668 6.67654 8.38574C6.72811 8.37012 6.77967 8.35918 6.83279 8.35137L6.92342 8.33887H6.99842H7.07967H7.19529H7.27029C7.31873 8.33887 7.36873 8.35137 7.41717 8.35918C7.51248 8.37637 7.60467 8.40137 7.69529 8.43418C7.85623 8.49199 8.00623 8.5748 8.14217 8.67793C8.34373 8.83105 8.51404 9.02324 8.63904 9.24355C8.68436 9.32012 8.72498 9.40137 8.75779 9.48418C8.78748 9.55293 8.80936 9.62637 8.82811 9.68105C8.84686 9.73574 8.84529 9.76231 8.85154 9.78887V9.82481C8.89373 10.1264 8.68279 10.4061 8.38123 10.4482C8.37498 10.4498 8.36873 10.4498 8.36404 10.4498C8.14686 10.4826 7.92654 10.3967 7.79061 10.2232Z",
    fill: "#422B0D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_27",
    d: "M13.5939 10.2232L13.5705 10.1936L13.508 10.1139L13.4377 10.0279C13.4064 9.99355 13.3689 9.95605 13.3314 9.91855C13.2924 9.88105 13.2517 9.84512 13.208 9.8123C13.1689 9.78262 13.1283 9.75605 13.0846 9.73262C13.0549 9.71543 13.0221 9.70293 12.9892 9.69668C12.9783 9.69512 12.9689 9.69512 12.958 9.69668C12.958 9.69668 12.9486 9.69668 12.9455 9.69668H12.9689H12.8877H12.8986H12.8814C12.8486 9.70293 12.8158 9.71543 12.7861 9.73262C12.7424 9.75605 12.7017 9.78262 12.6627 9.8123C12.6189 9.84512 12.5783 9.88105 12.5392 9.91855C12.4611 9.99355 12.3955 10.0748 12.3471 10.1232L12.2721 10.2123L12.2377 10.2514C12.0252 10.4873 11.6689 10.5248 11.4111 10.3404C11.2471 10.2264 11.1627 10.0279 11.1939 9.82949C11.1939 9.82949 11.2049 9.77012 11.2346 9.67324C11.2736 9.52168 11.3314 9.3748 11.4064 9.2373C11.5314 9.01699 11.7017 8.8248 11.9033 8.67168C12.0392 8.56855 12.1908 8.48574 12.3517 8.42793C12.3955 8.41074 12.4408 8.39668 12.4861 8.38574C12.5377 8.37012 12.5892 8.35918 12.6424 8.35137L12.733 8.33887H12.808H12.8892H13.0049H13.0799C13.1299 8.33887 13.1783 8.35137 13.2267 8.35918C13.4908 8.40449 13.7392 8.5123 13.9533 8.67168C14.1549 8.8248 14.3236 9.01699 14.4502 9.2373C14.4955 9.31387 14.5346 9.39512 14.5674 9.47793C14.5955 9.54199 14.6189 9.60762 14.6377 9.6748C14.6486 9.71074 14.6564 9.74668 14.6611 9.78262V9.81855C14.7049 10.1186 14.4955 10.3982 14.1955 10.4404C14.1892 10.442 14.183 10.442 14.1752 10.4436C13.9564 10.4779 13.7346 10.3951 13.5939 10.2232Z",
    fill: "#422B0D"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "facial_expressions_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "face-with-party-horn-and-party-hat_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "blush_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_28",
    opacity: 0.8,
    d: "M5.28125 13.7656C6.7914 13.7656 8.01562 12.6114 8.01562 11.1875C8.01562 9.76364 6.7914 8.60938 5.28125 8.60938C3.7711 8.60938 2.54688 9.76364 2.54688 11.1875C2.54688 12.6114 3.7711 13.7656 5.28125 13.7656Z",
    fill: "url(#paint4_radial_9893_10658)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_29",
    opacity: 0.8,
    d: "M14.7188 13.7656C16.2289 13.7656 17.4531 12.6114 17.4531 11.1875C17.4531 9.76364 16.2289 8.60938 14.7188 8.60938C13.2086 8.60938 11.9844 9.76364 11.9844 11.1875C11.9844 12.6114 13.2086 13.7656 14.7188 13.7656Z",
    fill: "url(#paint5_radial_9893_10658)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "prop_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "confetti_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_30",
    d: "M3.75 3.125C4.35406 3.125 4.84375 2.77522 4.84375 2.34375C4.84375 1.91228 4.35406 1.5625 3.75 1.5625C3.14594 1.5625 2.65625 1.91228 2.65625 2.34375C2.65625 2.77522 3.14594 3.125 3.75 3.125Z",
    fill: "#FF00A2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_31",
    d: "M8.35124 4.57356C8.60752 4.31728 8.54321 3.83746 8.20761 3.50186C7.872 3.16626 7.39219 3.10195 7.13591 3.35823C6.87963 3.61451 6.94394 4.09433 7.27954 4.42993C7.61514 4.76553 8.09496 4.82984 8.35124 4.57356Z",
    fill: "#FD3B3B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_32",
    d: "M11.7024 3.32789C12.2756 2.88419 12.5733 2.30875 12.3673 2.04261C12.1613 1.77647 11.5296 1.9204 10.9564 2.3641C10.3832 2.80779 10.0855 3.38323 10.2915 3.64937C10.4975 3.91552 11.1291 3.77158 11.7024 3.32789Z",
    fill: "#00EEFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_33",
    d: "M4.05598 13.6419C4.2727 13.5167 4.22103 13.0215 3.94057 12.5358C3.66012 12.05 3.25708 11.7577 3.04036 11.8828C2.82364 12.0079 2.8753 12.5032 3.15576 12.9889C3.43622 13.4747 3.83926 13.767 4.05598 13.6419Z",
    fill: "#0048FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_34",
    d: "M15.0781 18.125C15.3802 18.125 15.625 17.7402 15.625 17.2656C15.625 16.791 15.3802 16.4062 15.0781 16.4062C14.7761 16.4062 14.5312 16.791 14.5312 17.2656C14.5312 17.7402 14.7761 18.125 15.0781 18.125Z",
    fill: "#F63BBE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_35",
    d: "M18.2078 9.17696C18.6665 8.85409 18.9577 8.47796 18.8584 8.33683C18.7591 8.19571 18.3067 8.34303 17.8481 8.66589C17.3894 8.98876 17.0981 9.36489 17.1975 9.50602C17.2968 9.64715 17.7491 9.49982 18.2078 9.17696Z",
    fill: "#00CC00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_36",
    d: "M3.51245 18.912C3.69283 18.7936 3.60879 18.3467 3.32474 17.9138C3.0407 17.4809 2.66421 17.2259 2.48383 17.3443C2.30345 17.4626 2.38749 17.9095 2.67154 18.3424C2.95559 18.7753 3.33208 19.0303 3.51245 18.912Z",
    fill: "#0048FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_37",
    d: "M2.37133 15.8589C2.8878 15.8223 3.2941 15.6181 3.27883 15.4029C3.26355 15.1877 2.83249 15.043 2.31602 15.0796C1.79954 15.1163 1.39324 15.3204 1.40852 15.5356C1.42379 15.7508 1.85486 15.8956 2.37133 15.8589Z",
    fill: "#7ACDED"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_38",
    d: "M3.76864 13.8123C4.38859 13.7711 4.88327 13.619 4.87353 13.4726C4.86379 13.3262 4.35332 13.241 3.73336 13.2822C3.11341 13.3235 2.61874 13.4756 2.62848 13.622C2.63822 13.7684 3.14869 13.8536 3.76864 13.8123Z",
    fill: "#FF82B2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_39",
    d: "M18.5781 12.2188C18.4453 11.7595 18.1281 11.3751 17.7031 11.1563C16.9844 10.7657 16.0844 11.0329 15.6953 11.7517C15.6922 11.7563 15.6906 11.761 15.6875 11.7657C15.3625 12.3782 15.5922 13.1392 16.2031 13.4688C16.4453 13.6048 16.7297 13.6438 17 13.5782C17.2781 13.5157 17.5125 13.3329 17.6406 13.0782C17.7797 12.7845 17.7672 12.4407 17.6094 12.1563C17.4812 11.9063 17.2328 11.7407 16.9531 11.7188C16.7922 11.7157 16.6609 11.8438 16.6578 12.0048C16.6562 12.1501 16.7625 12.2751 16.9062 12.297C16.9859 12.3017 17.0578 12.3501 17.0938 12.422C17.1484 12.5329 17.1594 12.6626 17.125 12.7813C17.0719 12.886 16.975 12.961 16.8594 12.9845C16.7328 13.0173 16.5984 13.0001 16.4844 12.9376C16.3281 12.8548 16.2109 12.7142 16.1562 12.547C16.1094 12.3751 16.1266 12.1923 16.2031 12.0313C16.3125 11.8188 16.5047 11.6595 16.7344 11.5938C16.9641 11.5282 17.2078 11.5501 17.4219 11.6563C17.7016 11.8095 17.9094 12.0688 18 12.3751C18.0953 12.6829 18.0609 13.0157 17.9062 13.297C17.6094 13.8595 17.0312 14.2345 16.1875 14.2345C15.7031 14.2345 12.8203 14.1563 12.8203 14.1563L12.8547 14.8751L16.1562 14.8282C17.1406 14.8282 17.9531 14.4376 18.4219 13.5626C18.6687 13.1595 18.725 12.6673 18.5781 12.2188Z",
    fill: "url(#paint6_linear_9893_10658)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_40",
    d: "M10.9376 14.5312C11.0329 14.6328 11.1063 14.7516 11.1563 14.8812L12.9454 14.8703C12.9454 14.6359 12.9142 14.4016 12.9142 14.1516C12.4454 14.1359 11.4798 14.1203 11.1798 14.1094C11.136 14.2703 11.0501 14.4172 10.9282 14.5312H10.9376Z",
    fill: "#7F0099"
  })), /*#__PURE__*/React.createElement("g", {
    id: "hat_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_41",
    d: "M16.375 8.5625L16.9219 8.64062L17.0625 8.09375L17.1406 7.78125L14 7.34375C15.4219 8.42188 16.2813 8.5625 16.375 8.5625Z",
    fill: "#FF4545"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_42",
    d: "M18.8906 0.84375L17.625 1.5625L17.3125 1.73438L18.625 1.92188C18.7187 1.53125 18.8906 0.84375 18.8906 0.84375Z",
    fill: "#FF4545"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_43",
    d: "M16.0938 2.42188L14.7969 3.15625L18.1875 3.64062L18.4063 2.75L16.0938 2.42188Z",
    fill: "#FF4545"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_44",
    d: "M12.3906 4.51562H12.375L17.7656 5.29688L17.9688 4.46875L13.5781 3.84375L12.3906 4.51562Z",
    fill: "#FF4545"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_45",
    d: "M12.8438 6.3125L17.3438 6.95313L17.5625 6.10938L12.1406 5.32812C12.2031 5.5 12.3906 5.84375 12.8438 6.3125Z",
    fill: "#FF4545"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_46",
    d: "M13.5781 3.84375L17.9688 4.46875L18.1875 3.64062L14.7969 3.15625L13.5781 3.84375Z",
    fill: "#FF9C9C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_47",
    d: "M18.5312 2.26562C18.5312 2.26562 18.5781 2.04687 18.6094 1.9375L17.2969 1.75L16.0781 2.4375L18.3906 2.76563L18.5312 2.26562Z",
    fill: "#FF9C9C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_48",
    d: "M11.9219 4.76562L12.0937 5.26563C12.1 5.29375 12.1109 5.32031 12.125 5.34375L17.5469 6.125L17.75 5.29688L12.3594 4.53125L11.9219 4.76562Z",
    fill: "#FF9C9C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_49",
    d: "M13.9375 7.29688C13.9531 7.3125 13.9844 7.32812 14 7.34375L17.1406 7.79688L17.3438 6.96875L12.8438 6.32812C13.1859 6.675 13.5516 6.99844 13.9375 7.29688Z",
    fill: "#FF9C9C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_50",
    d: "M18.875 1.76562C19.2892 1.76562 19.625 1.42984 19.625 1.01562C19.625 0.601411 19.2892 0.265625 18.875 0.265625C18.4608 0.265625 18.125 0.601411 18.125 1.01562C18.125 1.42984 18.4608 1.76562 18.875 1.76562Z",
    fill: "#C93737"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Vector_51",
    d: "M11.2249 14.3485C11.4546 14.1501 11.5983 13.8704 11.6265 13.5673C11.6702 13.2626 11.5796 12.9548 11.3765 12.7235C11.0124 12.2454 9.99989 12.3642 9.99989 12.3642C9.72802 12.3751 9.41396 12.5048 9.45302 12.8173C9.50458 12.997 9.64989 13.1345 9.83114 13.1751C10.2311 13.2704 10.8015 13.1751 10.8171 13.5813C10.8358 14.0376 10.1358 13.8501 10.0796 14.3329C10.0233 14.8157 10.8171 14.7517 10.8171 15.0845C10.8171 15.3392 10.5561 15.3829 10.2811 15.4407C10.0452 15.4892 9.59208 15.5626 9.55614 15.8329C9.52021 16.1032 9.67489 16.436 10.3124 16.3392C11.3155 16.1829 11.653 15.6376 11.653 15.3001C11.6593 14.9345 11.503 14.586 11.2249 14.3485Z",
    fill: "#422B0D"
  }), /*#__PURE__*/React.createElement("g", {
    id: "smiling-eyes-grinning-face_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "eyes_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_52",
    d: "M7.79061 10.2232L7.76717 10.1936L7.70467 10.1139L7.62498 10.0279C7.59373 9.99355 7.55623 9.95605 7.51873 9.91855C7.47967 9.88105 7.43904 9.84512 7.39529 9.8123C7.35623 9.78262 7.31561 9.75605 7.27186 9.73262C7.24217 9.71543 7.20936 9.70293 7.17498 9.69668C7.16404 9.69512 7.15467 9.69512 7.14373 9.69668C7.14373 9.69668 7.14373 9.69668 7.13123 9.69668H7.15936H7.07811H7.08904C7.08279 9.69512 7.07811 9.69512 7.07186 9.69668C7.03748 9.70293 7.00467 9.71543 6.97498 9.73262C6.93123 9.75605 6.89061 9.78262 6.85154 9.8123C6.81092 9.84355 6.76873 9.88105 6.72811 9.91855C6.65154 9.99355 6.58436 10.0748 6.53748 10.1232L6.46248 10.2123L6.42811 10.2514C6.21561 10.4873 5.85936 10.5248 5.60154 10.3404C5.43748 10.2264 5.35311 10.0279 5.38436 9.82949C5.38436 9.82949 5.39529 9.77012 5.42342 9.67324C5.46717 9.52324 5.52967 9.37949 5.60779 9.24512C5.72967 9.02324 5.89529 8.82793 6.09373 8.67168C6.22967 8.56855 6.37967 8.48574 6.54061 8.42793C6.58436 8.41074 6.63123 8.39668 6.67654 8.38574C6.72811 8.37012 6.77967 8.35918 6.83279 8.35137L6.92342 8.33887H6.99842H7.07967H7.19529H7.27029C7.31873 8.33887 7.36873 8.35137 7.41717 8.35918C7.51248 8.37637 7.60467 8.40137 7.69529 8.43418C7.85623 8.49199 8.00623 8.5748 8.14217 8.67793C8.34373 8.83105 8.51404 9.02324 8.63904 9.24355C8.68436 9.32012 8.72498 9.40137 8.75779 9.48418C8.78748 9.55293 8.80936 9.62637 8.82811 9.68105C8.84686 9.73574 8.84529 9.76231 8.85154 9.78887V9.82481C8.89373 10.1264 8.68279 10.4061 8.38123 10.4482C8.37498 10.4498 8.36873 10.4498 8.36404 10.4498C8.14686 10.4826 7.92654 10.3967 7.79061 10.2232Z",
    fill: "#422B0D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_53",
    d: "M13.5939 10.2232L13.5705 10.1936L13.508 10.1139L13.4377 10.0279C13.4064 9.99355 13.3689 9.95605 13.3314 9.91855C13.2924 9.88105 13.2517 9.84512 13.208 9.8123C13.1689 9.78262 13.1283 9.75605 13.0846 9.73262C13.0549 9.71543 13.0221 9.70293 12.9892 9.69668C12.9783 9.69512 12.9689 9.69512 12.958 9.69668C12.958 9.69668 12.9486 9.69668 12.9455 9.69668H12.9689H12.8877H12.8986H12.8814C12.8486 9.70293 12.8158 9.71543 12.7861 9.73262C12.7424 9.75605 12.7017 9.78262 12.6627 9.8123C12.6189 9.84512 12.5783 9.88105 12.5392 9.91855C12.4611 9.99355 12.3955 10.0748 12.3471 10.1232L12.2721 10.2123L12.2377 10.2514C12.0252 10.4873 11.6689 10.5248 11.4111 10.3404C11.2471 10.2264 11.1627 10.0279 11.1939 9.82949C11.1939 9.82949 11.2049 9.77012 11.2346 9.67324C11.2736 9.52168 11.3314 9.3748 11.4064 9.2373C11.5314 9.01699 11.7017 8.8248 11.9033 8.67168C12.0392 8.56855 12.1908 8.48574 12.3517 8.42793C12.3955 8.41074 12.4408 8.39668 12.4861 8.38574C12.5377 8.37012 12.5892 8.35918 12.6424 8.35137L12.733 8.33887H12.808H12.8892H13.0049H13.0799C13.1299 8.33887 13.1783 8.35137 13.2267 8.35918C13.4908 8.40449 13.7392 8.5123 13.9533 8.67168C14.1549 8.8248 14.3236 9.01699 14.4502 9.2373C14.4955 9.31387 14.5346 9.39512 14.5674 9.47793C14.5955 9.54199 14.6189 9.60762 14.6377 9.6748C14.6486 9.71074 14.6564 9.74668 14.6611 9.78262V9.81855C14.7049 10.1186 14.4955 10.3982 14.1955 10.4404C14.1892 10.442 14.183 10.442 14.1752 10.4436C13.9564 10.4779 13.7346 10.3951 13.5939 10.2232Z",
    fill: "#422B0D"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_9893_10658",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(9.93594 11.733) scale(7.91542)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FDE030"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#F7C02B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4A223"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_9893_10658",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(5.28124 11.7374) scale(2.97621 2.67252)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED7770"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#ED7770",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_9893_10658",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(19.7687 183.217) scale(3.03594)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED7770"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#ED7770",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_9893_10658",
    x1: 12.8422,
    y1: 12.926,
    x2: 18.6531,
    y2: 12.926,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#004054"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#45A4FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_9893_10658",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(5.28124 11.7374) scale(2.97621 2.67252)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED7770"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#ED7770",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_9893_10658",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(19.7687 183.217) scale(3.03594)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED7770"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#ED7770",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_9893_10658",
    x1: 12.8422,
    y1: 12.926,
    x2: 18.6531,
    y2: 12.926,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#004054"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#45A4FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartyingFace);
export default __webpack_public_path__ + "static/media/partying_face.c7e76120f4275abebc70cb138b4781de.svg";
export { ForwardRef as ReactComponent };